import Label from 'emerald-ui/lib/Label';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Label, componentName: 'Label' }], 'Label'),
  description: 'A Label is a colored badge to represent a status.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Label },
      whiteBackground: true,
      code: `<Label>Open</Label>`,
    },
  ],
};
